import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import { Emitter } from 'vscode/vscode/vs/base/common/event';
import { IStorageService } from 'vscode/vscode/vs/platform/storage/common/storage.service';
import { Memento } from 'vscode/vscode/vs/workbench/common/memento';
import { CHAT_PROVIDER_ID } from 'vscode/vscode/vs/workbench/contrib/chat/common/chatParticipantContribTypes';

let ChatWidgetHistoryService = class ChatWidgetHistoryService {
    constructor(storageService) {
        this._onDidClearHistory = ( new Emitter());
        this.onDidClearHistory = this._onDidClearHistory.event;
        this.memento = ( new Memento('interactive-session', storageService));
        const loadedState = this.memento.getMemento(1 , 1 );
        for (const provider in loadedState.history) {
            loadedState.history[provider] = ( loadedState.history[provider].map(entry => typeof entry === 'string' ? { text: entry } : entry));
        }
        this.viewState = loadedState;
    }
    getHistory() {
        return this.viewState.history?.[CHAT_PROVIDER_ID] ?? [];
    }
    saveHistory(history) {
        if (!this.viewState.history) {
            this.viewState.history = {};
        }
        this.viewState.history[CHAT_PROVIDER_ID] = history;
        this.memento.saveMemento();
    }
    clearHistory() {
        this.viewState.history = {};
        this.memento.saveMemento();
        this._onDidClearHistory.fire();
    }
};
ChatWidgetHistoryService = ( __decorate([
    ( __param(0, IStorageService))
], ChatWidgetHistoryService));

export { ChatWidgetHistoryService };
